import { render } from "./mobileSidebarNavigation.vue?vue&type=template&id=1950566a"
import script from "./mobileSidebarNavigation.vue?vue&type=script&lang=js"
export * from "./mobileSidebarNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__